export default __webpack_public_path__ + "static/bannerPubliMBPE-0d8db4d7cdccaec8d222a8de4f8ef1c2.png";